import moment from "moment";
import "moment/locale/it";

moment.locale("it");
